import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { companyContact } from "../data/content";

export default function SiteFooter() {
  return (
    <footer className="bg-[#0A2540] text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-[1.3fr_0.8fr_0.9fr] md:px-8">
        <div>
          <p className="font-heading text-2xl font-black" data-testid="footer-brand-name">TalentBridge Consulting</p>
          <p className="mt-4 max-w-xl text-sm leading-7 text-slate-300" data-testid="footer-brand-description">
            Calgary-based hiring support for companies that need help with job postings and candidate sourcing.
          </p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400" data-testid="footer-navigation-title">Navigation</p>
          <div className="mt-4 grid gap-3 text-sm font-semibold text-slate-200">
            <Link to="/services" data-testid="footer-services-link" className="hover:text-white">Services</Link>
            <Link to="/employers" data-testid="footer-employers-link" className="hover:text-white">Employer form</Link>
            <Link to="/candidates" data-testid="footer-candidates-link" className="hover:text-white">Candidate registration</Link>
            <Link to="/booking" data-testid="footer-booking-link" className="hover:text-white">Booking calendar</Link>
          </div>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400" data-testid="footer-contact-title">Contact</p>
          <div className="mt-4 grid gap-3 text-sm text-slate-200">
            <span className="flex items-center gap-3" data-testid="footer-email-text"><Mail className="h-4 w-4" /> {companyContact.email}</span>
            <span className="flex items-center gap-3" data-testid="footer-location-text"><MapPin className="h-4 w-4" /> {companyContact.location}</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 px-5 py-5 text-center text-xs text-slate-400" data-testid="footer-copyright">
        © 2026 TalentBridge Consulting. Built for professional hiring conversations.
      </div>
    </footer>
  );
}